export default (payload) => ({
  type: 'DELETE_LEAD_STATE',
  payload,
});
